export const ReportIdConst = {
  CADDataByMonth: '314',
  CADPialSummary: '331',
  CADEventsData: '330'
};
